import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Chip, Stack } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import ProfileForm from '../components/forms/ProfileForm';
import ChangePasswordForm from '../components/forms/ChangePasswordForm';
import UserAvatar from '../components/common/UserAvatar';

const ProfilePage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  const getPerfilDisplayName = (perfil: string) => {
    const perfis: Record<string, string> = {
      'administrador': 'Administrador',
      'financeiro': 'Financeiro',
      'suporte': 'Suporte',
      'cliente': 'Cliente',
      'bot': 'Bot'
    };
    return perfis[perfil] || perfil;
  };

  return (
    <Box>
      <Box mb={1.5}>
        <Typography variant="h5" fontWeight="bold" component="h1" gutterBottom sx={{ mb: 0.25 }}>
          Meu Perfil
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Informações pessoais e segurança
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined">
            <CardContent sx={{ textAlign: 'center', py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
              <UserAvatar
                size={96}
                showUploadButton={true}
                editable={true}
                sx={{
                  mx: 'auto',
                  mb: 1,
                  border: '2px solid',
                  borderColor: 'divider',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  borderRadius: '50%',
                }}
              />

              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5, lineHeight: 1.3 }}>
                {user.nome}
              </Typography>

              <Stack direction="row" spacing={0.75} justifyContent="center" flexWrap="wrap" useFlexGap sx={{ mb: 0.5 }}>
                <Chip label={getPerfilDisplayName(user.perfil)} color="primary" size="small" />
                <Chip
                  label={user.status === 'ativo' ? 'Ativo' : 'Inativo'}
                  color={user.status === 'ativo' ? 'success' : 'error'}
                  size="small"
                />
              </Stack>

              <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                Membro desde {user.createdAt ? new Date(user.createdAt).toLocaleDateString('pt-BR') : 'N/A'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid
          item
          xs={12}
          md={8}
          sx={{
            '& .MuiPaper-root': {
              p: 2,
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ProfileForm user={user} />
            </Grid>
            <Grid item xs={12}>
              <ChangePasswordForm />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfilePage; 